import { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import { getPublicFormules } from "../lib/api";
import { chf } from "../lib/format";

// Bannière d'upsell : affiche le montant restant avant la livraison offerte.
// Ne s'affiche que si un SEUIL est configuré et que le panier ne l'atteint pas encore.
export default function FreeDeliveryBanner({ subtotal, freeDelivery }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    getPublicFormules().then((f) => setCfg(f?.free_delivery || null)).catch(() => setCfg(null));
  }, []);

  if (!cfg?.enabled) return null;
  const threshold = cfg.threshold_chf;
  if (threshold == null) return null;                 // toujours offerte → pas d'upsell
  if (freeDelivery || subtotal >= threshold) return null; // déjà débloquée

  const remaining = Math.max(0, threshold - subtotal);
  const pct = Math.min(100, Math.round((subtotal / threshold) * 100));

  return (
    <div className="rounded-xl p-3 mb-3" style={{ background: "#fff7ed", border: "1px solid #fed7aa" }} data-testid="free-delivery-banner">
      <div className="flex items-center gap-2 text-sm font-semibold" style={{ color: "#9a3412" }}>
        <Truck size={16} />
        <span>Plus que <span data-testid="free-delivery-remaining">{chf(remaining)}</span> pour la <strong>livraison offerte</strong> 🎉</span>
      </div>
      <div className="mt-2 h-2 rounded-full overflow-hidden" style={{ background: "#fde6d3" }}>
        <div className="h-full rounded-full" style={{ width: `${pct}%`, background: "#f97316", transition: "width 300ms ease" }} />
      </div>
    </div>
  );
}
